import { createSlice } from "@reduxjs/toolkit";
import { Terrain } from "../../utils/layer-types";


const initialState = {
    id: 0,
    name: Terrain,
    label: 'Terrain providers',
    collapsed: false,
    elements:[
        {
            id: 1,
            name: "d1_area_dem",
            label: "D1 Area DEM",
            type: Terrain,
            visible: true,
            url:'https://app.csds.om/madayn/terrain/CMR_4326' //https://app.csds.om/madayn
        },
        {
            id: 2,
            name: "d1_area_dtm",
            label: "D1 Area DTM",
            type: Terrain,
            visible: false,
            url:'https://app.csds.om/madayn/terrain/DTM_4326'
        }
    ]
}

export const terrainSlice = createSlice({
    name: 'terrain',
    initialState, 
    reducers: {
        changeCollaps: (state) => {
            state.collapsed = !state.collapsed;
        },
        setTerrain: (state, { payload }) => {
            state.elements = state.elements.map(e => { return { ...e, visible: e.id === payload.id ? true : false }; });
        }
    },
})
export const { changeCollaps, setTerrain } = terrainSlice.actions